import { Button, Steps, Divider, Slider, Modal } from "antd";
import "antd/dist/antd.css";
import { useState } from "react";
import splash from "./dashboard.webp";
import splashMobile from "./dashboardMobile.webp";
import coracle from "./assets/coracle.svg";
import dnnenterprises from "./assets/dnnenterprises.svg";
import imperialdynamicscorp from "./assets/imperialdynamicscorp.svg";
import nexustech from "./assets/nexustech.svg";
import stock1 from "./assets/stock1.png";
import stock2 from "./assets/stock2.png";
import stock3 from "./assets/stock3.png";
import video from "./assets/video.png";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import Contact from "./Contact";
import TOS from "./TOS";
import PrivacyPolicy from "./PrivacyPolicy";
import {
  MenuOutlined,
  CloseOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import MobilePartners from "./MobilePartners";
import SolutionsSlider from "./SolutionsSlider";
import useScrollPosition from "@react-hook/window-scroll";
import moment from "moment";

const { Step } = Steps;

function App() {
  const [devices, setDevices] = useState(1);
  const [annualCost, setAnnualCost] = useState(539.89);
  const [monthlyCost, setMonthlyCost] = useState(49.99);
  const [savings, setSavings] = useState(5.0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [tos, setTos] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);

  const updateCost = (val) => {
    if (typeof val === "string") {
      val = parseInt(val);
    }
    setDevices(val);
    if (val < 11) {
      setMonthlyCost((val * 49.99).toFixed(2));
      setAnnualCost((val * 539.89).toFixed(2));
      setSavings((val * 49.99 * 0.1).toFixed(2));
    } else if (val > 10 && val < 31) {
      setMonthlyCost((val * 44.99).toFixed(2));
      setAnnualCost((val * 485.89).toFixed(2));
      setSavings((val * 44.99 * 0.1).toFixed(2));
    } else if (val > 30 && val < 51) {
      setMonthlyCost((val * 39.99).toFixed(2));
      setAnnualCost((val * 431.89).toFixed(2));
      setSavings((val * 39.99 * 0.1).toFixed(2));
    } else if (val > 50) {
      setMonthlyCost((val * 34.99).toFixed(2));
      setAnnualCost((val * 377.89).toFixed(2));
      setSavings((val * 34.99 * 0.1).toFixed(2));
    }
  };
  const offer = () => {
    if (devices !== 10 || devices !== 30 || devices !== 50) {
      if (devices > 5 && devices < 11) {
        return (
          <div className="offerDiv">
            <p>
              You're <span>{11 - devices} devices</span> away from unlocking
              even more savings!
            </p>
          </div>
        );
      } else if (devices > 26 && devices < 31) {
        return (
          <div className="offerDiv">
            <p>
              You're <span>{31 - devices} devices</span> away from unlocking
              even more savings!
            </p>
          </div>
        );
      } else if (devices > 40 && devices < 51) {
        return (
          <div className="offerDiv">
            <p>
              You're <span>{51 - devices} devices</span> away from unlocking
              even more savings!
            </p>
          </div>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
  const tosModal = () => {
    return (
      <Modal
        title="Terms of Service"
        visible={tos}
        onCancel={() => setTos(false)}
        footer={[]}
        width={900}
      >
        <div className="tosModal">
          <TOS />
        </div>
      </Modal>
    );
  };
  const ppModal = () => {
    return (
      <Modal
        title="Privacy Policy"
        visible={privacyPolicy}
        onCancel={() => setPrivacyPolicy(false)}
        footer={[]}
        width={900}
      >
        <div className="tosModal">
          <PrivacyPolicy />
        </div>
      </Modal>
    );
  };

  const calculateSavings = () => {
    let savings = monthlyCost - annualCost / 12;
    return savings.toFixed(2);
  };

  const currencyFormat = (value) => {
    let formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(value);
    return formatted;
  };

  return (
    <div style={{ width: "100%", margin: 0, padding: 0 }}>
      <div className="navigation">
        <div className="navBar">
          <a href="#home">{logo()}</a>
          <div className="navMid">
            <a className="navItem" href="#home">
              Home
            </a>
            <a className="navItem" href="#partners">
              Partners
            </a>
            <a className="navItem" href="#product">
              Product
            </a>
            <a className="navItem" href="#solutions">
              Solutions
            </a>
            <a className="navItem" href="#pricing">
              Pricing
            </a>
            <a className="navItem" href="#testimonials">
              Testimonials
            </a>
            <a className="navItem" href="#faq">
              FAQ
            </a>
            <a className="navItem" href="#contact">
              Contact Us
            </a>
          </div>
          <div className="navEnd">
            <a className="navItem" href="https://app.hyperdisplay.tv/login">
              Login
            </a>
            <a href="https://app.hyperdisplay.tv/register">
              <Button className="getStartedNav">Get Started</Button>
            </a>
          </div>
          <div className="hamburger">
            <a
              className="mobileStartMenu"
              href="https://app.hyperdisplay.tv/register"
            >
              Get Started
            </a>
            {menuOpen ? (
              <CloseOutlined
                width={22}
                height={14}
                onClick={() => setMenuOpen(false)}
              />
            ) : (
              <MenuOutlined
                width={22}
                height={14}
                onClick={() => setMenuOpen(true)}
              />
            )}
          </div>
        </div>
        <div className={`mobileMenu ${menuOpen ? "showMM" : "hideMM"}`}>
          <ul>
            <li>
              <a
                className="navItem"
                href="#home"
                onClick={() => setMenuOpen(false)}
              >
                Home
              </a>
            </li>
            <li>
              <a
                className="navItem"
                href="#partners"
                onClick={() => setMenuOpen(false)}
              >
                Partners
              </a>
            </li>
            <li>
              <a
                className="navItem"
                href="#product"
                onClick={() => setMenuOpen(false)}
              >
                Product
              </a>
            </li>
            <li>
              <a
                className="navItem"
                href="#solutions"
                onClick={() => setMenuOpen(false)}
              >
                Solutions
              </a>
            </li>
            <li>
              <a
                className="navItem"
                href="#pricing"
                onClick={() => setMenuOpen(false)}
              >
                Pricing
              </a>
            </li>
            <li>
              <a
                className="navItem"
                href="#testimonials"
                onClick={() => setMenuOpen(false)}
              >
                Testimonials
              </a>
            </li>
            <li>
              <a
                className="navItem"
                href="#faq"
                onClick={() => setMenuOpen(false)}
              >
                FAQ
              </a>
            </li>
            <li>
              <a
                className="navItem"
                href="#contact"
                onClick={() => setMenuOpen(false)}
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                className="navItem"
                href="https://app.hyperdisplay.tv/login"
                onClick={() => setMenuOpen(false)}
              >
                Login
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="hero" id="home">
        <div className="heroCircle" />
        <div className="heroContent">
          <h1>Digital Signage Made Easy</h1>
          <p>
            The only digital signage platform you need to upload, schedule and
            <br />
            display content affordably and professionally from the web.
          </p>
          <div className="heroBtns">
            <a href="https://app.hyperdisplay.tv/register">
              <Button className="getStarted">Get Started</Button>
            </a>
            <a href="#contact">
              <Button className="lightBtn">Contact Us</Button>
            </a>
          </div>
          <img src={splash} className="splashImg" alt="" />
          <img src={splashMobile} className="splashImgMobile" alt="" />
          <div className="partners" id="partners">
            <p>TRUSTED BY THE BEST</p>
            <h3>Our Partners</h3>
            <div className="partnerImgs">
              <img src={coracle} className="partnerLogo" alt="" />
              <img src={dnnenterprises} className="partnerLogo" alt="" />
              <img src={imperialdynamicscorp} className="partnerLogo" alt="" />
              <img src={nexustech} className="partnerLogo" alt="" />
            </div>
            <div className="mobilePartnerImgs">
              <MobilePartners />
            </div>
          </div>
        </div>
      </div>
      <div className="section1" id="product">
        <div className="coreFeatures">
          <p>CORE FEATURES</p>
          <h3>How can you benefit from us?</h3>
          <div className="coreFeaturesCols">
            <div className="coreCol">
              <img src={stock1} alt="" />
              {play()}
              <h4>SIMPLE CONTENT MANAGEMENT</h4>
              <p>
                Fast, reliable and easy to use. Remotely schedule and manage
                content at a single location or across your entire network of
                devices.
              </p>
            </div>
            <div className="coreCol">
              <img src={stock2} alt="" />
              {plus()}
              <h4>FAST AND EASY ENROLLMENT</h4>
              <p>
                Our digital signage software is really easy to set up. Just
                write down a 12-digit code, confirm your device and you are good
                to go.
              </p>
            </div>
            <div className="coreCol">
              <img src={stock3} alt="" />
              {lock()}
              <h4>SECURITY, RELIABILITY AND SIMPLICITY</h4>
              <p>
                Create user controls and custom permissions. Enterprise-grade
                security includes SSL, firewall and password policies.{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="howItWorks" id="howitworks">
          <div className="HIWContent">
            <div className="HIWLeft">
              <p>HOW IT WORKS</p>
              <h4>Getting started is fast and easy</h4>
              <Steps direction="vertical" current={4}>
                <Step title="Create an account" />
                <Step title="Enroll your device" />
                <Step title="Upload your media" />
                <Step title="Display media across devices" />
              </Steps>
              <a href="https://app.hyperdisplay.tv/register">
                <Button className="getStarted" style={{ marginTop: "50px" }}>
                  Get Started
                </Button>
              </a>
            </div>
            <div className="HIWRight">
              <img src={video} alt="" />
            </div>
          </div>
        </div>
        <div className="solutions" id="solutions">
          <p>SOLUTIONS</p>
          <h3>Who are we for?</h3>
          <h4>
            From restaurants and cafés to healthcare and education, we have it
            covered.
          </h4>
          <SolutionsSlider />
        </div>
      </div>
      <div className="section2" id="pricing">
        <div className="pricing">
          <p className="pricingFirstP">PRICING</p>
          <h3>Pick a solution that fits you</h3>
          <h4>
            Our digital signage software subscription plans come with everything
            you need to upload and <br />
            manage effective digital signage. You can cancel anytime, free of
            charge.
          </h4>
          <div className="pickAPlan">
            <div className="planWrapper">
              <h3>Choose a plan</h3>
              <p className="pricingP">
                Pick how many devices you need and tailor your subscription
                plan.
              </p>
              <Divider />
              <div>
                <p className="splitText">
                  <span className="rightText">$100 setup fee per device</span>
                  Devices
                </p>
                <Slider
                  min={1}
                  max={100}
                  onChange={(value) => updateCost(value)}
                  trackStyle={{ backgroundColor: "#0047C2" }}
                  handleStyle={{
                    width: "22px",
                    height: "22px",
                    boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.2)",
                    marginTop: "-9px",
                    border: "none",
                  }}
                  value={typeof devices === "number" ? devices : 0}
                />
                <div className="priceQuan">
                  <div className="quantityBox">
                    <p
                      className="dsc1"
                      style={{ marginTop: "15px", color: "#29303d" }}
                    >
                      Quantity
                    </p>
                    <input
                      type="number"
                      className="quantityInput"
                      value={devices}
                      onChange={(e) => updateCost(e.target.value)}
                    ></input>
                  </div>
                  <div className="totalSelected">
                    <p className="dsc1" style={{ fontWeight: "700" }}>
                      Total
                    </p>
                    <div className="tagStyle">
                      <p
                        className="dsc2"
                        style={{
                          fontWeight: "700",
                          color: "white",
                          verticalAlign: "middle",
                          padding: "10px",
                        }}
                      >
                        ${parseInt(devices) * 100}
                      </p>
                    </div>
                  </div>
                </div>
                <Divider />
                <div className="splitPlans">
                  <div className="planLeft">
                    <h3>Monthly plan</h3>
                    <p>Pay your subscription monthly.</p>
                    <p>30-day trial period.</p>
                    <h1>
                      {currencyFormat(monthlyCost)}
                      <span>/mo</span>
                    </h1>
                    <div className="planLeftUnderMobile">
                      <p className="planBenefits">Including</p>
                      <p>{checkIcon()}Unlimited devices</p>
                      <p>{checkIcon()}Unlimited media uploads</p>
                      <p>{checkIcon()}Unlimited scheduling</p>
                      <p>{checkIcon()}Unlimited users</p>
                      <p>{checkIcon()}Customer support</p>
                      <a href="https://app.hyperdisplay.tv/register">
                        <Button className="planStartBtn">
                          Get started with monthly
                        </Button>
                      </a>
                    </div>
                  </div>
                  <div className="planRight">
                    <h3>Annual plan</h3>
                    <p>Pay your subscription annually.</p>
                    <p>30-day trial period.</p>
                    <h1>
                      {currencyFormat(annualCost)}
                      <span>/yr</span>
                    </h1>
                    <div className="planRightUnderMobile">
                      <p className="planBenefits">Including</p>
                      <p>{checkIcon()}Unlimited devices</p>
                      <p>{checkIcon()}Unlimited media uploads</p>
                      <p>{checkIcon()}Unlimited scheduling</p>
                      <p>{checkIcon()}Unlimited users</p>
                      <p>{checkIcon()}Customer support</p>
                      <a href="https://app.hyperdisplay.tv/register">
                        <Button className="planStartBtn">
                          Get started with annual
                        </Button>
                      </a>
                    </div>
                  </div>
                </div>
                <Divider />
                <div className="offers">
                  <p>
                    Choose the annual plan and save ${calculateSavings()}/mo!
                  </p>
                  {offer()}
                </div>
                <Divider />
                <div className="splitPlans">
                  <div className="planLeftUnder">
                    <p className="planBenefits">Including</p>
                    <p>{checkIcon()}Unlimited devices</p>
                    <p>{checkIcon()}Unlimited media uploads</p>
                    <p>{checkIcon()}Unlimited scheduling</p>
                    <p>{checkIcon()}Unlimited users</p>
                    <p>{checkIcon()}Customer support</p>
                    <a href="https://app.hyperdisplay.tv/register">
                      <Button className="planStartBtn">
                        Get started with monthly
                      </Button>
                    </a>
                  </div>
                  <div className="planRightUnder">
                    <p className="planBenefits">Including</p>
                    <p>{checkIcon()}Unlimited devices</p>
                    <p>{checkIcon()}Unlimited media uploads</p>
                    <p>{checkIcon()}Unlimited scheduling</p>
                    <p>{checkIcon()}Unlimited users</p>
                    <p>{checkIcon()}Customer support</p>
                    <a href="https://app.hyperdisplay.tv/register">
                      <Button className="planStartBtn">
                        Get started with annual
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="over100">
            <div className="over100offer">
              <h4>Are you managing 100+ devices?</h4>
              <p>Reach out to unlock even more discount potential</p>
            </div>
            <div className="over100contact">
              <a href="#contact">
                <Button className="lightBtn">Contact Us</Button>
              </a>
            </div>
          </div>
        </div>
        <div className="trustedByTheBest" id="testimonials">
          <p>PREMIUM SERVICE</p>
          <h3>What our clients say about us</h3>
          <div className="testimonialSlider">
            <Testimonials />
          </div>
        </div>
        <div className="faq" id="faq">
          <p>FAQ</p>
          <h3>Questions we hear most often</h3>
          <FAQ />
        </div>
      </div>
      <div className="section3" id="contact">
        <div className="contactUs">
          <div className="contactLeft">
            <p>CONTACT US</p>
            <h3>Get in touch</h3>
            <h4>Have questions or concerns? We're here to help.</h4>
            <div className="contactEmails">
              <p>General Inquiries</p>
              <a href="mailto:support@hyperdisplay.tv">
                support@hyperdisplay.tv
              </a>
            </div>
          </div>
          <div className="contactRight">
            <Contact />
          </div>
        </div>
        <div className="didntComeThisFar">
          <p>GET STARTED</p>
          <h2>You didn't come this far for nothing</h2>
          <h4>
            Start uploading, scheduling, and displaying content affordably and
            professionally from the web
          </h4>
          <a href="https://app.hyperdisplay.tv/register">
            <Button className="getStartedThisFar">Get Started</Button>
          </a>
        </div>
      </div>
      <div className="footer">
        <div className="footerCols">
          <div className="footCol">{logo()}</div>
          <div className="footCol">
            <p>Company</p>
            <a href="#partners">Partners</a>
            <br />
            <a href="#pp" onClick={() => setPrivacyPolicy(true)}>
              Privacy Policy
            </a>
            <br />
            <a href="#home" onClick={() => setTos(true)}>
              Terms of Service
            </a>
            <br />
          </div>
          <div className="footCol">
            <p>Product</p>
            <a href="#product">Features</a>
            <br />
            <a href="#howitworks">How it works</a>
            <br />
            <a href="#solutions">Solutions</a>
            <br />
            <a href="#pricing">Pricing</a>
            <br />
          </div>
          <div className="footCol">
            <p>Support</p>
            <a href="#testimonials">Testimonials</a>
            <br />
            <a href="#faq">FAQ</a>
            <br />
            <a href="#contact">Contact Us</a>
            <br />
          </div>
        </div>
      </div>
      <div className="footSign">
        <a href="#home">
          All rights reserved &copy; Copyright 2021 - {moment().format("YYYY")}{" "}
          | HyperDisplay
        </a>
        <p>
          A product of{" "}
          <a href="https://liveuptothehype.com" className="hypertekFooter">
            Hypertek Solutions LLC
          </a>{" "}
          | Live Up To The Hype!
        </p>
      </div>
      {tosModal()}
      {ppModal()} (
      <div
        className={`backToTop ${
          useScrollPosition(30) > 1000 ? "showToTop" : null
        }`}
        onClick={() => window.scrollTo(0, 0)}
      >
        <ArrowUpOutlined />
      </div>
    </div>
  );
}
const logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1420.67 323.89"
      width="160"
      height="40"
    >
      <path
        fill="#0047c2"
        d="M349.81 220.53h-22.88v-49.04h-39.66v49.04h-22.88V103.35h22.88v47.89h39.66v-47.89h22.88v117.18Zm107.3-117.17-35.22 69.12v48.06h-22.71v-48.06l-35.22-69.12h24.85l21.89 47.23 21.56-47.23h24.85Zm98.25 36.53c0 10.31-3.4 18.87-10.2 25.67-7.24 7.24-16.73 10.86-28.47 10.86h-22.55v44.11h-22.88V103.35h45.42c11.74 0 21.23 3.62 28.47 10.86 6.8 6.8 10.2 15.36 10.2 25.67Zm-22.88 0c0-4.83-1.54-8.72-4.61-11.68-3.07-2.96-7.19-4.44-12.34-4.44h-21.39v32.09h21.39c5.16 0 9.27-1.45 12.34-4.36 3.07-2.91 4.61-6.77 4.61-11.6Zm119.32 80.64h-77.19V103.35h77.19v20.41h-54.31v27.48h46.25v20.41h-46.25v28.47h54.31v20.41Zm111.08 0h-26.5l-22.88-46.74h-16.46v46.74h-22.88V103.35h45.92c11.63 0 20.96 3.51 27.98 10.53 6.69 6.69 10.04 15.14 10.04 25.34 0 7.79-2.14 14.48-6.42 20.08-3.84 4.94-8.83 8.5-14.98 10.7l26.17 50.52Zm-27.65-81.38c0-4.58-1.54-8.29-4.61-11.13-3.07-2.84-7.08-4.26-12.01-4.26h-21.56v30.78h21.56c4.94 0 8.94-1.42 12.01-4.26 3.07-2.84 4.61-6.55 4.61-11.13Zm131.66 22.3c0 13.06-.33 21.62-.99 25.67-1.43 9-5.05 16.4-10.86 22.22-7.46 7.46-17.77 11.19-30.94 11.19h-42.3V103.35h42.3c13.17 0 23.48 3.73 30.94 11.19 5.81 5.82 9.43 13.06 10.86 21.72.66 3.95.99 12.34.99 25.18Zm-22.88 0c0-9.43-.28-16.07-.82-19.91-.66-4.5-2.03-8.01-4.11-10.53-3.95-4.83-9.66-7.24-17.12-7.24h-17.28v76.36h17.28c7.46 0 13.17-2.41 17.12-7.24 2.08-2.52 3.46-6.2 4.11-11.03.55-4.06.82-10.86.82-20.41Zm69.13 59.08h-22.88V103.35h22.88v117.18Zm103.18-34.56c0 11.08-4.09 19.78-12.26 26.08-8.17 6.31-18.57 9.46-31.19 9.46-18.32 0-32.58-5.16-42.79-15.47l14.81-14.81c6.58 6.58 16.02 9.87 28.31 9.87 13.82 0 20.74-4.83 20.74-14.48 0-4.39-1.15-7.65-3.46-9.79-2.3-2.14-5.82-3.54-10.53-4.2l-14.15-1.97c-20.74-2.85-31.1-13.77-31.1-32.75 0-10.64 3.67-19.23 11.03-25.76 7.35-6.53 17.28-9.79 29.79-9.79 15.8 0 28.41 4.55 37.85 13.66l-14.48 14.32c-5.6-5.37-13.61-8.06-24.03-8.06-5.82 0-10.29 1.4-13.41 4.2-3.13 2.8-4.69 6.34-4.69 10.61 0 3.4 1.23 6.25 3.7 8.56 2.47 2.3 6.01 3.79 10.62 4.44l13.82 1.97c9.98 1.43 17.45 4.44 22.38 9.05 6.03 5.71 9.05 13.99 9.05 24.85Zm105.49-46.08c0 10.31-3.4 18.87-10.2 25.67-7.24 7.24-16.73 10.86-28.47 10.86h-22.55v44.11h-22.88V103.35h45.42c11.74 0 21.23 3.62 28.47 10.86 6.8 6.8 10.2 15.36 10.2 25.67Zm-22.88 0c0-4.83-1.54-8.72-4.61-11.68-3.07-2.96-7.19-4.44-12.34-4.44h-21.39v32.09h21.39c5.16 0 9.27-1.45 12.34-4.36 3.07-2.91 4.61-6.77 4.61-11.6Zm118.17 80.64h-76.03V103.35h22.88v96.77h53.16v20.41Zm109.11 0h-23.86l-6.91-20.74h-41.64l-7.08 20.74h-23.86l42.62-117.18h17.94l42.79 117.18Zm-36.86-39.99-14.32-42.62-14.81 42.62h29.13Zm131.32-77.18-35.22 69.12v48.06h-22.71v-48.06l-35.22-69.12h24.85l21.89 47.23 21.56-47.23h24.85Z"
      />
      <path
        fill="#0047c2"
        fill-rule="evenodd"
        d="M198.89 0h47.67c-.05.83-.46 1.43-.69 2.06-.11.57-.23 1.14-.34 1.71h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.69h-.17v.51h-.17v.51h-.17v.51H244v.51h-.17v.51h-.17c-.06.4-.11.8-.17 1.2h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17c-.06.4-.11.8-.17 1.2h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17l-.17 1.03h-.17l-.17 1.03h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17l-.17 1.03h-.17c-.11.57-.23 1.14-.34 1.71-3.05 8.36-5.38 17.35-8.4 25.72v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03H222v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71H205l-.17 1.03h-.17c-.11.57-.23 1.14-.34 1.71-3.5 9.59-6.13 19.89-9.6 29.49v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51H192v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17l-.17 1.03h-.17c-.11.57-.23 1.14-.34 1.71-3.05 8.36-5.38 17.35-8.4 25.72-.06.4-.11.8-.17 1.2h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17l-.17 1.03h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17v.51h-.17l-.17 1.03h-.17c-.06.4-.11.8-.17 1.2-.52 1.44-1.2 3.01-1.54 4.63-1.13.41-3.2.17-4.63.17h-43.21C143.22 175.01 171.06 87.49 198.89 0ZM82.99 62.41h47.84v.17h-.17l-.17 1.03h-.17v.51h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.69h-.17l-.17 1.03c-.73 1.82-1.33 4.01-2.06 5.83-.11.57-.23 1.14-.34 1.71h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17l-.17 1.03h-.17l-.17 1.03h-.17c-.06.4-.11.8-.17 1.2-3.36 9.2-5.93 19.08-9.26 28.29-.06.4-.11.8-.17 1.2h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17l-.17 1.03h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51H102v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17l-.17 1.03h-.17l-.17 1.03h-.17c-.06.4-.11.8-.17 1.2-2.84 7.8-5.06 16.2-7.89 24v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69c-3.35 9.2-5.93 19.08-9.26 28.29-.06.4-.11.8-.17 1.2h-.17l-.17 1.03h-.17v.51h-.17v.51h-.17v.51h-.17c-.11.57-.23 1.14-.34 1.71h-.17v.51h-.17l-.17 1.03h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17c-.06.34-.11.69-.17 1.03H67v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17v.69h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17v.51h-.17l-.17 1.03h-.17c-.06.4-.11.8-.17 1.2-.44 1.11-.94 2.3-1.2 3.6l-.51.17v.17h-.34l-.17.34H59l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34v.17c-.17.06-.34.11-.51.17l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34H8v.17l-.51.17-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17-.17.34h-.34l-.17.34h-.34l-.17.34h-.34v.17l-.51.17c26.8-86.39 54.47-173.57 82.13-260.72Z"
      />
    </svg>
  );
};
const play = () => {
  return (
    <svg
      width="170"
      height="170"
      viewBox="0 0 170 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <circle cx="75" cy="75" r="45" fill="#F2F6FC" />
        <circle cx="75" cy="75" r="42" stroke="white" strokeWidth="6" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.1764 63.852C83.9829 60.6284 79.7581 59 75.5333 59C71.3085 59 67.0837 60.5952 63.8569 63.8187C60.63 67.0755 59 71.2961 59 75.5166C59 79.7372 60.5968 83.9577 63.8236 87.1813C67.0504 90.4048 71.2752 92 75.5 92C79.7248 92 83.9496 90.4048 87.1764 87.1813C90.4032 83.9577 92 79.7372 92 75.5166C92 71.2961 90.4032 67.0755 87.1764 63.852ZM86.0121 85.9849C83.1179 88.8761 79.3256 90.3384 75.5333 90.3384C71.7409 90.3384 67.9486 88.8761 65.0544 85.9849C62.127 83.0937 60.6966 79.3051 60.6966 75.5166C60.6966 71.7281 62.1603 67.9396 65.0544 65.0483C67.9486 62.1571 71.7409 60.6949 75.5333 60.6949C79.3256 60.6949 83.1179 62.1571 86.0121 65.0483C88.9062 67.9396 90.37 71.7281 90.37 75.5166C90.37 79.3051 88.9395 83.0937 86.0121 85.9849ZM82.619 73.7885L77.7954 70.997L73.005 68.2387C72.5393 67.9728 72.0071 67.9063 71.5413 68.0393C71.0756 68.1722 70.6431 68.4713 70.377 68.9366C70.3071 69.0297 70.2698 69.1391 70.2309 69.2535L70.2309 69.2535C70.2143 69.3023 70.1973 69.3521 70.1774 69.4018C70.1598 69.4548 70.1515 69.5171 70.1426 69.5838L70.1426 69.5838C70.1348 69.6427 70.1265 69.705 70.1109 69.7674V69.9003V75.5498V81.1994C70.1109 81.7311 70.3438 82.2296 70.6764 82.5619C71.0423 82.9275 71.5081 83.1269 72.0403 83.1269C72.3397 83.1269 72.9718 82.861 73.1381 82.7613L77.8619 80.0363H77.8952L77.9284 80.003L82.8186 77.1782C83.2843 76.9124 83.5837 76.4804 83.7167 75.9819C83.75 75.8822 83.75 75.7492 83.75 75.6163C83.75 74.5196 82.619 73.7885 82.619 73.7885ZM81.9536 75.7492L77.13 78.5408C77.0968 78.5408 77.0635 78.574 77.0635 78.574L72.3397 81.2991C72.3065 81.3323 72.1401 81.3988 72.0736 81.3988C72.0071 81.3988 71.9405 81.3656 71.874 81.3323L71.874 81.3323C71.8407 81.2991 71.8075 81.1994 71.8075 81.1329V75.5166V69.9003V69.8671V69.8006C71.8075 69.8006 71.8075 69.7674 71.8407 69.7674C71.8407 69.7674 71.874 69.7341 71.874 69.7009C71.8906 69.6843 71.9156 69.6677 71.9405 69.6511L71.9405 69.6511C71.9655 69.6344 71.9904 69.6178 72.0071 69.6012H72.1734C72.19 69.6178 72.2067 69.6261 72.2233 69.6344C72.2399 69.6427 72.2566 69.6511 72.2732 69.6677L76.997 72.3927C77.0302 72.426 77.0635 72.426 77.0635 72.426H77.0968L81.9204 75.2175C81.9869 75.2508 82.12 75.3505 82.12 75.4502C82.12 75.5831 82.0202 75.716 81.9536 75.7492Z"
        fill="#0047C2"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="170"
          height="170"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="10" dy="10" />
          <feGaussianBlur stdDeviation="20" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
const plus = () => {
  return (
    <svg
      width="170"
      height="170"
      viewBox="0 0 170 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <circle cx="75" cy="75" r="45" fill="#F2F6FC" />
        <circle cx="75" cy="75" r="42" stroke="white" strokeWidth="6" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60 75C60 83.2713 66.7287 90 75 90C83.2713 90 90 83.2713 90 75C90 66.7287 83.2713 60 75 60C66.7287 60 60 66.7287 60 75ZM61.875 75C61.875 67.7625 67.7625 61.875 75 61.875C82.2375 61.875 88.125 67.7625 88.125 75C88.125 82.2375 82.2375 88.125 75 88.125C67.7625 88.125 61.875 82.2375 61.875 75ZM68.4375 75.9375C67.92 75.9375 67.5 75.5175 67.5 75C67.5 74.4825 67.92 74.0625 68.4375 74.0625H74.0625V68.4375C74.0625 67.92 74.4825 67.5 75 67.5C75.5175 67.5 75.9375 67.92 75.9375 68.4375V74.0625H81.5625C82.08 74.0625 82.5 74.4825 82.5 75C82.5 75.5175 82.08 75.9375 81.5625 75.9375H75.9375V81.5625C75.9375 82.08 75.5175 82.5 75 82.5C74.4825 82.5 74.0625 82.08 74.0625 81.5625V75.9375H68.4375Z"
        fill="#0047C2"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="170"
          height="170"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="10" dy="10" />
          <feGaussianBlur stdDeviation="20" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
const lock = () => {
  return (
    <svg
      width="170"
      height="170"
      viewBox="0 0 170 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <circle cx="75" cy="75" r="45" fill="#F2F6FC" />
        <circle cx="75" cy="75" r="42" stroke="white" strokeWidth="6" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.0938 73.4375C65.5259 73.4375 65.0625 73.8995 65.0625 74.4688V88.9062C65.0625 89.4755 65.5259 89.9375 66.0938 89.9375H84.6562C85.2241 89.9375 85.6875 89.4755 85.6875 88.9062V74.4688C85.6875 73.8995 85.2241 73.4375 84.6562 73.4375H82.5938H68.1562H66.0938ZM67.125 71.375V67.25C67.125 62.7001 70.8251 59 75.375 59C79.9249 59 83.625 62.7001 83.625 67.25V71.375H84.6562C86.3612 71.375 87.75 72.7624 87.75 74.4688V88.9062C87.75 90.6126 86.3612 92 84.6562 92H66.0938C64.3887 92 63 90.6126 63 88.9062V74.4688C63 72.7624 64.3887 71.375 66.0938 71.375H67.125ZM81.5625 71.375V67.25C81.5625 63.8386 78.7864 61.0625 75.375 61.0625C71.9636 61.0625 69.1875 63.8386 69.1875 67.25V71.375H81.5625ZM74.3438 82.1745C73.3368 81.7658 72.625 80.7771 72.625 79.625C72.625 78.1084 73.8584 76.875 75.375 76.875C76.8916 76.875 78.125 78.1084 78.125 79.625C78.125 80.7771 77.4132 81.7658 76.4062 82.1745V85.4688C76.4062 86.038 75.9443 86.5 75.375 86.5C74.8057 86.5 74.3438 86.038 74.3438 85.4688V82.1745ZM74.6875 79.625C74.6875 79.2455 74.9969 78.9375 75.375 78.9375C75.7531 78.9375 76.0625 79.2455 76.0625 79.625C76.0625 80.0045 75.7531 80.3125 75.375 80.3125C74.9969 80.3125 74.6875 80.0045 74.6875 79.625Z"
        fill="#0047C2"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="170"
          height="170"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="10" dy="10" />
          <feGaussianBlur stdDeviation="20" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
const checkIcon = () => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.862 1.19299L4.09966 7.95533C4.0401 8.01489 3.94365 8.01489 3.88423 7.95533L0.0445687 4.11553C-0.0148562 4.05624 -0.0148562 3.9598 0.0445687 3.90023L0.977555 2.96725C1.03712 2.90782 1.13356 2.90782 1.19299 2.96725L3.99208 5.76621L9.71372 0.0445687C9.77342 -0.0148562 9.86959 -0.0148562 9.92915 0.0445687L10.862 0.977555C10.9216 1.03698 10.9216 1.13328 10.862 1.19299Z"
        fill="#0047C2"
      />
    </svg>
  );
};
export default App;
